import { ResponsiveValue } from '@gousto-internal/citrus-react';

export const middleColumnLayout: ResponsiveValue<string> = [
  '1 / span 12', // Full width for mobile,
  '1 / span 12', // Full width for small screen,
  '3 / span 8', // Centered otherwise
];

export const middleColumnLayout6Col: ResponsiveValue<string> = [
  '1 / span 12', // Full width for mobile,
  '1 / span 12', // Full width for small screen,
  '4 / span 6', // Centered otherwise
];
